import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TableModule } from 'primeng/table'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'
import { InputTextModule } from 'primeng/inputtext'
import { MultiSelectModule } from 'primeng/multiselect'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-recommended-prices-live-quotes-table',
  template: `
    <div class="card">
      <div class="card-body">
        <div class="table-header-container" style="padding-bottom: 1rem">
          <div>
            <span class="text-small-roman" style="font-weight: bold">
              Live Quotes</span
            >
          </div>
          <p-multiSelect
            [options]="cols"
            [(ngModel)]="selectedColumns"
            optionLabel="header"
            selectedItemsLabel="{0} columns selected"
            [style]="{ 'min-width': '200px' }"
            placeholder="Choose Columns"></p-multiSelect>
          <div style="display: flex; gap: 1.5rem;">
            <p-button
              class="secondary-btn"
              [rounded]="true"
              label="Reset sorting"
              [outlined]="true"
              severity="help">
              <ng-template pTemplate="icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.13843 6.75101L8.19576 5.80768L11.3338 2.66968L14.4718 5.80768L13.5291 6.75101L12.0004 5.22234V12.667H10.6671V5.22234L9.13843 6.75101Z"
                    fill="#8A00E5" />
                  <path
                    d="M3.99996 10.7779V3.33328H5.33396V10.7779L6.86196 9.24928L7.8053 10.1919L4.6673 13.3299L1.5293 10.1919L2.47196 9.24928L3.99996 10.7779Z"
                    fill="#8A00E5" />
                </svg>
              </ng-template>
            </p-button>
            <p-button
              class="secondary-btn"
              [rounded]="true"
              label="Reset filtering"
              (click)="recLiveQuotesPricesTable.reset()"
              [outlined]="true"
              severity="help">
              <ng-template pTemplate="icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.31998 9.33333L1.33398 2H14.6673L8.66732 9.33333V14H7.33398V9.33333H7.31998ZM11.854 3.33333H4.14398L7.95332 8H8.03598L11.854 3.33333Z"
                    fill="#8A00E5" />
                </svg>
              </ng-template>
            </p-button>
            <p-button
              class="secondary-btn"
              [rounded]="true"
              label="Download csv"
              (click)="exportCsv(recLiveQuotesPricesTable)"
              [outlined]="true"
              severity="help">
              <ng-template pTemplate="icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5727 6.15333L12.426 7.18L7.99935 10.8667L3.57268 7.18L4.42602 6.15333L7.33268 8.58V2H8.66602V8.58L11.5727 6.15333Z"
                    fill="#8A00E5" />
                  <path
                    d="M13.3327 14V12.6667H2.66602V14H13.3327Z"
                    fill="#8A00E5" />
                </svg>
              </ng-template>
            </p-button>
          </div>
        </div>
        <p-table
          #recLiveQuotesPricesTable
          [columns]="selectedColumns"
          [value]="data"
          styleClass="p-datatable-striped"
          [tableStyle]="{ 'min-width': '50rem' }"
          [paginator]="true"
          [loading]="loading"
          [rows]="50"
          [scrollable]="true"
          styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
          sortMode="multiple"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[50, 100, 150, { showAll: 'All' }]"
          [scrollable]="true"
          scrollHeight="53vh">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th
                class="table-header text-small-strong"
                *ngFor="let col of columns"
                pSortableColumn="{{ col.field }}">
                <div style="display: flex; align-items: center">
                  {{ col.header }}
                  <div class="sort-wrapper">
                    <p-sortIcon
                      [field]="col.field"
                      ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"
                      class="mr-auto">
                    </p-sortIcon>

                    <span class="sort-tooltip">
                      Tip: Hold Ctrl (or Cmd on Mac) to sort by multiple columns
                    </span>
                  </div>
                  <p-columnFilter
                    type="text"
                    display="menu"
                    style="margin-left: 1rem"
                    [field]="col.field"></p-columnFilter>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr class="text-small-roman">
              <td
                *ngFor="let col of cols"
                [ngStyle]="{
                  'text-align': col.align === 'right' ? 'right' : 'left'
                }">
                @if (col.field === 'INC_REVENUE' )
                {
                {{ rowData[col.field] | number : '1.2-2' }}
                }

              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr class="text-small-roman">
              <td
                *ngFor="let col of columns"
                [ngStyle]="{
                  'text-align': col.align === 'right' ? 'right' : 'left'
                }">
                @if (col.field === 'NAME') {
                <a (click)="handleQuoteClicked(rowData)" class="quote-link">
                  {{ rowData[col.field] }}
                </a>
                } @else if(col.field === 'CREATEDDATE' || col.field === 'SUBMITTEDDATE__C') {
                  {{ rowData[col.field] | date:'mediumDate'}}
                } @else {
                {{ rowData[col.field] }}
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td style="border: none;" colspan="5">
                No results for your search terms.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  `,
  styles: [
    `
      .table-header {
        background-color: #cf9bff40;
        padding: 0.5rem 0.75rem;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        white-space: nowrap;
      }

      .quote-link{
        color: #8a00e5;
        cursor: pointer;
      }

      .text-small-strong {
        color: #8a00e5 !important;
      }

      td {
        border-right: 1px solid #969696;
      }

      .table-header-container {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
      }
      .sort-wrapper {
        position: relative;
        display: inline-flex;
        align-items: center;
        cursor: pointer;
      }

      .sort-tooltip {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.2s ease;
        position: absolute;
        bottom: -40px;
        left: 50%;
        transform: translateX(-50%);
        background: #333;
        color: white;
        padding: 5px 8px;
        font-size: 12px;
        border-radius: 4px;
        white-space: nowrap;
        z-index: 9999;
        pointer-events: none;
      }

      .sort-wrapper:hover .sort-tooltip {
        visibility: visible;
        opacity: 1;
      }

    `,
  ],
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    TooltipModule,
    InputTextModule,
    MultiSelectModule,
    FormsModule,
  ],
})
export class RecommendedPricesLiveQuotesTableComponent {
  public data: any = {}

  cols: any[] = [
    { field: 'NAME', header: 'Quote Number', align: 'default' },
    { field: 'ACCOUNT_NAME__C', header: 'Account Name', align: 'default' },
    { field: 'APPROVALSTATUS__C', header: 'Approval Status', align: 'default' },
    { field: 'CREATEDBYID', header: 'Created By ID', align: 'default' },
    { field: 'CREATEDDATE', header: 'Created Date', align: 'default' },
    { field: 'PRODUCT_LINE_TEXT__C', header: 'Product Line', align: 'default' },
    {
      field: 'REGIONAL_COUNTRY__C',
      header: 'Regional Country',
      align: 'default',
    },
    {
      field: 'SBQQ__DAYSQUOTEOPEN__C',
      header: 'Days Quote Open',
      align: 'right',
    },
    { field: 'SBQQ__STATUS__C', header: 'Quote Status', align: 'default' },
    { field: 'SUBMITTEDDATE__C', header: 'Submitted Date', align: 'default' },
    { field: 'INC_REVENUE', header: 'Incremental Revenue', align: 'right' },
  ]

  selectedColumns = this.cols

  @Input() quoteId: string | undefined
  @Input() loading!: boolean

  @Input()
  set tableData(data: any) {
    this.data = data
  }

  @Output() quoteClicked: EventEmitter<any> = new EventEmitter<any>()

  handleQuoteClicked(rowData: any) {
    this.quoteClicked.emit(rowData)
  }

  exportCsv(dt: any) {
    const original = this.data
    try {
      const rows = Array.isArray(this.data) ? this.data : []
      const formatted = rows.map((row: any) => {
        const copy: any = {}
        Object.keys(row || {}).forEach((k) => {
          const v = row[k]
          if (v == null) {
            copy[k] = v
            return
          }
          if (v instanceof Date || this.isIsoDateString(v)) {
            copy[k] = this.formatDate(v)
          } else {
            copy[k] = v
          }
        })
        return copy
      })

      dt.value = formatted
      dt.exportCSV()
    } finally {
      dt.value = original
    }
  }

  private isIsoDateString(val: any): boolean {
    return typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(val)
  }

  private formatDate(val: any): string {
    const d = val instanceof Date ? val : new Date(val)
    if (isNaN(d.getTime())) return String(val)
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const yyyy = d.getFullYear()
    return `${dd}-${mm}-${yyyy}`
  }
}
